import React from "react";

/**
 * Renders a SVG icon for "worked".
 *
 * @return {JSX.Element} SVG icon for "worked"
 */
export const WorkedIcon = ({ cls }) => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_63_3270)">
        <path
          d="M25.8333 2.66667H24.5V1.33333C24.5 0.597333 23.904 0 23.1667 0C22.4293 0 21.8333 0.597333 21.8333 1.33333V2.66667H11.1667V1.33333C11.1667 0.597333 10.5707 0 9.83333 0C9.096 0 8.5 0.597333 8.5 1.33333V2.66667H7.16667C3.49067 2.66667 0.5 5.65733 0.5 9.33333V25.3333C0.5 29.0093 3.49067 32 7.16667 32H25.8333C29.5093 32 32.5 29.0093 32.5 25.3333V9.33333C32.5 5.65733 29.5093 2.66667 25.8333 2.66667ZM7.16667 5.33333H25.8333C28.0387 5.33333 29.8333 7.128 29.8333 9.33333V10.6667H3.16667V9.33333C3.16667 7.128 4.96133 5.33333 7.16667 5.33333ZM25.8333 29.3333H7.16667C4.96133 29.3333 3.16667 27.5387 3.16667 25.3333V13.3333H29.8333V25.3333C29.8333 27.5387 28.0387 29.3333 25.8333 29.3333ZM25.8333 18.6667C25.8333 19.4027 25.2373 20 24.5 20H8.5C7.76267 20 7.16667 19.4027 7.16667 18.6667C7.16667 17.9307 7.76267 17.3333 8.5 17.3333H24.5C25.2373 17.3333 25.8333 17.9307 25.8333 18.6667ZM16.5 24C16.5 24.736 15.904 25.3333 15.1667 25.3333H8.5C7.76267 25.3333 7.16667 24.736 7.16667 24C7.16667 23.264 7.76267 22.6667 8.5 22.6667H15.1667C15.904 22.6667 16.5 23.264 16.5 24Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_63_3270">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
